import styled from 'styled-components';
import { Menu } from 'antd';

export const MenuWrapper = styled(Menu)`
  /* .ant-menu-overflow-item {
    position: unset !important;
  } */
  border-width: 0;
  .ant-menu-item,
  .ant-menu-submenu-title {
    font-weight: 500;
    padding: 0 !important;
    /* margin: 0 20px; */
    /* padding: 0 !important; */
    color: #5e6278;
    transition: 0s !important;
    > .ant-menu-title-content {
      padding: 0.65rem 1rem;
    }
    &.ant-menu-item-active {
      &:after {
        content: '';
        display: none;
      }
    }
    &.ant-menu-item-selected {
      &:after {
        content: '';
        display: none;
      }
      .ant-menu-title-content {
        border-radius: 0.475rem;
        color: #5e6278;
        background-color: rgba(245, 248, 250, 0.8);
      }
    }
  }
  .ant-menu-submenu {
    &.ant-menu-submenu-open {
      &:after {
        display: none;
      }
    }
    &:hover {
      &:after {
        display: none;
      }
    }
  }
`;
